import { CSSProperties, forwardRef, PropsWithChildren, UIEvent } from 'react';

interface IProps {
  style?: CSSProperties;
  threshold?: number;
  onEndReached?: () => void;
  onScroll?: (ctx: IScrollContext) => void;
}

interface IScrollContext {
  isAtBottom: boolean;
}

export const ScrollArea = forwardRef<HTMLDivElement, PropsWithChildren<IProps>>(
  ({ children, style = {}, threshold = 0, onEndReached, onScroll }, ref) => {
    const handleScroll = (e: UIEvent<HTMLDivElement>) => {
      const target = e.currentTarget;
      const distanceFromBottom = Math.floor(
        target.scrollHeight - target.scrollTop - target.clientHeight,
      );
      // Account for 1px browser rendering difference
      const isAtBottom = distanceFromBottom <= threshold + 1;

      if (isAtBottom && onEndReached) {
        onEndReached();
      }

      onScroll?.({ isAtBottom });
    };

    return (
      <div
        ref={ref}
        style={{
          overflow: 'auto',
          position: 'relative',
          width: '100%',
          ...style,
        }}
        onScroll={handleScroll}
      >
        {children}
      </div>
    );
  },
);

ScrollArea.displayName = 'ScrollArea';
